module.exports = __webpack_public_path__ + "img/eliza-ivanova-mask-and-moon.4c141de.jpg";